import React from 'react';

import './TransactionDetail.scss';

interface InfoHeaderItemProps {
    id: string;
    label: string;
    name?: string;
}

export const InfoHeaderItem = ({ id, label, name }: InfoHeaderItemProps) => {
    if (!name) {
        return null;
    }

    return (
        <p className={`info-${id} info-item`} aria-label={label}>
            {name}
        </p>
    );
};
